import apiClient from "../../app/apiClient";
import { normalizeProject } from "../admin/pages/projectDirectory";
const projectPath = (id) => "/client/project/" + encodeURIComponent(id);
export function pageData(data) {
  if (!data || !Array.isArray(data.content) || !Number.isInteger(data.totalElements) || !Number.isInteger(data.totalPages)) throw new Error("The server returned an invalid paginated response.");
  return data;
}
export const clientApi = {
  summary: async () => (await apiClient.get("/client/dashboard/summary")).data,
  projects: async (page = 0, search = "") => {
    const { data } = await apiClient.get("/client/projects", { params: { page, size: 9, search, sort: "createdAt,desc" } });
    const result = pageData(data);
    return { ...result, content: result.content.map(normalizeProject) };
  },
  project: async (id) => normalizeProject((await apiClient.get(projectPath(id))).data),
  images: async (id) => {
    const { data } = await apiClient.get(projectPath(id) + "/images");
    if (!Array.isArray(data)) throw new Error("The server returned an invalid image list.");
    return data;
  },
  updates: async (id, page, order) => pageData((await apiClient.get(id ? projectPath(id) + "/project-updates" : "/client/project-updates", { params: { page, size: 10, sort: "createdAt," + (order === "oldest" ? "asc" : "desc") } })).data),
  documents: async (page) => pageData((await apiClient.get("/client/documents", { params: { page, size: 10, sort: "createdAt,desc" } })).data),
};
